import { useEffect, useState } from "react";
import { openTapeStream } from "../api/stream.js";
import type { TickerTapeSnapshot } from "../types.js";

export type TapeConnection = "connecting" | "open" | "error";

export interface TapeStreamState {
  snapshot: TickerTapeSnapshot | null;
  connection: TapeConnection;
  /** Wall-clock ms of the last pane update (audit timestamp — Date.now() is fine). */
  lastUpdateMs: number | null;
}

const INITIAL: TapeStreamState = { snapshot: null, connection: "connecting", lastUpdateMs: null };

/** Subscribe to the DeltaTape SSE stream for a symbol; re-subscribes on change. */
export function useTapeStream(token: string | null, symbol: string): TapeStreamState {
  const [state, setState] = useState<TapeStreamState>(INITIAL);

  useEffect(() => {
    if (!token) {
      setState(INITIAL);
      return;
    }
    setState(INITIAL);
    const close = openTapeStream(token, symbol, {
      onReady: () => setState((s) => ({ ...s, connection: "open" })),
      onPane: (snapshot) =>
        setState((s) => ({ ...s, snapshot, connection: "open", lastUpdateMs: Date.now() })),
      onError: () => setState((s) => ({ ...s, connection: "error" })),
    });
    return close;
  }, [token, symbol]);

  return state;
}
